// frontend/src/components/HistoryPanel.js
import React, { useEffect, useState } from 'react';
const TASK_TYPE_LABELS = {
  all: '全部',
  car_single_page: '单页',
  car_directory: '整个PDF',
  car_table: '表格提取',
  device_calibration: '设备校准',
  device_calibration_batch: '设备校准多文件',
};
export default function HistoryPanel({
  title = '历史记录',
  emptyText = '暂无历史记录，点击“查询历史记录”后加载。',
  historyLoading,
  historyTasks,
  onLoad,
  onView
}) {
  const [isExpanded, setIsExpanded] = useState(true);
  const [selectedTaskType, setSelectedTaskType] = useState('all');
  const hasHistory = historyTasks.length > 0;
  const taskTypes = Array.from(new Set(historyTasks.map((task) => task.task_type).filter(Boolean)));
  const filteredTasks = selectedTaskType === 'all'
    ? historyTasks
    : historyTasks.filter((task) => task.task_type === selectedTaskType);

  useEffect(() => {
    if (hasHistory) {
      setIsExpanded(true);
    }
  }, [hasHistory]);

  useEffect(() => {
    if (selectedTaskType !== 'all' && !taskTypes.includes(selectedTaskType)) {
      setSelectedTaskType('all');
    }
  }, [selectedTaskType, taskTypes]);

  return (
    <div className="history-panel">
      <div className="history-header">
        <h4>{title}</h4>
        <div className="history-actions">
          {hasHistory && (
            <div className="history-filter">
              <label htmlFor="history-task-type" className="history-filter-label">类型：</label>
              <select
                id="history-task-type"
                className="history-filter-select"
                value={selectedTaskType}
                onChange={(e) => setSelectedTaskType(e.target.value)}
                disabled={historyLoading}
              >
                <option value="all">{TASK_TYPE_LABELS.all}</option>
                {taskTypes.map((taskType) => (
                  <option key={taskType} value={taskType}>
                    {TASK_TYPE_LABELS[taskType] || taskType}
                  </option>
                ))}
              </select>
            </div>
          )}
          {hasHistory && (
            <button
              className="btn secondary"
              onClick={() => setIsExpanded((prev) => !prev)}
              disabled={historyLoading}
            >
              {isExpanded ? '收起历史数据' : '展开历史数据'}
            </button>
          )}
          <button className="btn secondary" onClick={onLoad} disabled={historyLoading}>
            {historyLoading ? '加载中...' : '查询历史记录'}
          </button>
        </div>
      </div>
      {hasHistory ? (
        isExpanded ? (
          <div className="history-list">
            {filteredTasks.map((task) => (
              <div className="history-item" key={task.id}>
                <div className="history-item-main">
                  <strong>{task.task_no}</strong>
                  <span>{task.filename || '未知文件'}</span>
                  <span>{TASK_TYPE_LABELS[task.task_type] || task.task_type}</span>
                  <span>{task.created_at ? task.created_at.replace('T', ' ').slice(0, 19) : '-'}</span>
                </div>
                <button className="btn primary" onClick={() => onView(task.id)} disabled={historyLoading}>查看</button>
              </div>
            ))}
            {!filteredTasks.length && (
              <p className="history-empty">当前筛选条件下暂无历史数据。</p>
            )}
          </div>
        ) : (
          <p className="history-empty">历史数据已收起，点击“展开历史数据”查看。</p>
        )
      ) : (
        <p className="history-empty">{emptyText}</p>
      )}
    </div>
  );
}